<template>
	<div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''"
		:style="openType == 'mob' ? 'background:#fff': ''">
		<div class="" :class="openType != 'mob' ? 'container_w_h bgfff' : ''">
			<div class="top page_bg" id="top" :class="openType != 'mob' ? 'obt' : ''">
				<template v-if="openType == 'mob'">
					<div class="flex_items flex_between bgfff plr20 top-timer mb10">
						<div class="" @click="show = true">
							<div :class="timer ? '' : 'ca6'">{{timer ? timer : '选择开始日期'}}
								<van-icon name="arrow-down" />
							</div>
						</div>
						<div class="" @click="show2 = true">
							<div :class="timerEnd ? '' : 'ca6'">{{timerEnd ? timerEnd : '选择结束日期'}}
								<van-icon name="arrow-down" />
							</div>
						</div>
					</div>
					<div class="flex_items flex_between bgfff plr20 top-timer mb10" @click="show1 = true">
						<div class="">人员选择</div>
						<div :class="user ? '' : 'ca6'">{{user ? user : '请选择人员'}}
							<van-icon name="arrow" />
						</div>
					</div>
				</template>
				<template v-else>
					<div class="flex_items flex_between bgfff plr20 top-timer mb10">
						<el-date-picker format="yyyy-MM-dd" v-model="timer" class="mr10" align="right"
							@change="pcPicerChange" type="date" placeholder="请选择开始日期">
						</el-date-picker>
						<el-date-picker v-model="timerEnd" align="right" @change="pcPicerChange1" type="date"
							placeholder="请选择结束日期">
						</el-date-picker>
					</div>
					<div class="flex_items flex_between bgfff plr20 top-timer mb10">
						<div class="">人员选择</div>
						<el-select v-model="user" placeholder="请选择人员" @change="pcUserChange">
							<el-option v-for="item in userList" :key="item.id" :label="item.name1" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</template>
				<!-- <div class="top-content bgfff pt20 plr20">
					<div class="mb20 txt_center">项目出勤情况</div>
					<div class="flex flex_between flex_items ">
						<div class="">
							<div class="txt_center mb10">30</div>
							<div class="ca6">总人数</div>
						</div>
						<div class="">
							<div class="txt_center mb10">30</div>
							<div class="ca6">签到人数</div>
						</div>
						<div class="">
							<div class="txt_center mb10">30</div>
							<div class="ca6">请假人数</div>
						</div>
						<div class="">
							<div class="txt_center mb10">30</div>
							<div class="ca6">到场人数</div>
						</div>
					</div>
				</div> -->
			</div>
			<div class="content page_bg" style="padding-bottom: 150px;box-sizing: border-box;"
				:style="openType != 'mob' ? 'padding-top: '+pcPt+'px' : 'padding-top: 150px;min-height:100vh'">
				<div class="bgfff" v-for="(item, index) in list" :key="index">
					<div class="bor_b plr20 pt20 pb20 " v-if="t ==1">
						<div class="flex_between flex_items w100">
              <div class="">
                <div class="mb10">{{item.user ? item.user.name : ''}}</div>
                <div class="ca6">{{item.date}}</div>
              </div>
              <div v-if="item.is_sign" class="main_color">{{item.time == 'forenoon' ? '上午' : item.time == 'afternoon' ? '下午' : ''}}{{item.sign_confirm ? '已到场' : '已签到'}}</div>
              <div v-if="item.is_leave" class="red">{{item.time == 'forenoon' ? '上午' : item.time == 'afternoon' ? '下午' : ''}}已请假</div>
            </div>
            <div class="ca6" v-if="item.remark2">备注：{{item.remark2}}</div>

					</div>
					<div class="bor_b plr20 pt20 pb20 flex_between flex_items" v-else>
						<div class="w100">
							<div class="mb10 flex flex_between flex_items">
								{{item.name ? item.name : ''}}
								<div class="">应出勤:{{item.days.all}}</div>
							</div>
							<div class="ca6 flex flex_between flex_items">
								<div class="main_color" style="width: 33%;">出勤:{{item.days.sign}}</div>
								<div class="main_color_red txt_center" style="width: 33%;">请假:{{item.days.leave}}</div>
								<div class="txt_right" style="width: 30%;">缺勤:{{item.days.absence}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="empty" v-if="list.length == 0">
					暂无数据
				</div>
			</div>
		</div>
		<Popup v-model="show" position="bottom">
			<DatetimePicker v-model="timerS" @cancel="show = false" @confirm="confirm" type="date" title="选择开始日期">
			</DatetimePicker>
		</Popup>
		<Popup v-model="show2" position="bottom">
			<DatetimePicker v-model="timerSE" @cancel="show2 = false" @confirm="confirm1" type="date" title="选择结束日期">
			</DatetimePicker>
		</Popup>
		<Popup v-model="show1" position="bottom">
			<Picker v-model="user" :show-toolbar="true" @cancel="show1 = false" value-key="name1" :columns="userList"
				@confirm="confirmUser" title="选择人员">
			</Picker>
		</Popup>
		<div class="right-circle overHidden" style="background-color: dodgerblue;">
			<form :action="url" method="post">
				<input type="hidden" name="api_token" :value="token" />
				<button type="submit" style="background: #00D8CC;width: 100%;height: 100%;border: 0;">导出</button>
			</form>
		</div>
	</div>
</template>

<script>
	import {
		openType,
		pcContentHeight
	} from '@/utils/tool.js'
	import {
		List,
		Popup,
		Picker,
		DatetimePicker
	} from "vant";
	export default ({
		components: {
			List,
			Popup,
			DatetimePicker,
			Picker
		},
		data() {
			return {
				openType: openType(),
				loading: false,
				finished: false,
				timer: '',
				timerS: new Date(),
				timerSE: new Date(),
				timerEnd: '',
				show: false,
				show2: false,
				list: [],
				user: '',
				userList: [],
				show1: false,
				selectObj: {},
				pcPt: 120,
				url: '',
				token: localStorage.getItem('token'),
				t:0
			}
		},
		methods: {
			confirm(e) {
				this.selectObj.date_start = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate();
				this.timer = e.getFullYear() + '年' + (e.getMonth() + 1) + '月' + e.getDate() + '日';
				this.show = false;
				this.getList()
			},
			confirm1(e) {
				this.selectObj.date_end = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate();
				this.timerEnd = e.getFullYear() + '年' + (e.getMonth() + 1) + '月' + e.getDate() + '日';
				this.show2 = false;
				this.getList()
			},
			confirmUser(e) {
				this.user = e.name;
				this.show1 = false;
				this.selectObj.user_id = e.id;
				this.getList()
			},
			clickFn(t) {
				this.handleClick = t
			},
			pcPicerChange() {
				let e = this.timer;
				this.selectObj.date_start = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate();
				this.getList()
			},
			pcPicerChange1() {
				let e = this.timerEnd;
				this.selectObj.date_end = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate();
				this.getList()
			},
			pcUserChange() {
				this.selectObj.user_id = this.user
				this.getList()
			},
			getList() {
				if(this.t == 2){
					this.selectObj.project_id = this.id
					this.api.signInfo(this.selectObj).then(res => {
						this.list = res.data
					})
				}else{
					this.api
						.signLogs(this.selectObj, this.id)
						.then((res) => {
							this.list = res.data
						});
				}
			},
			getUserList() {
				this.api.projectUser({}, this.id).then(res => {
					let arr = []
					res.data.map(r => {
						if(r.role == 'member'){
							r.name1 = r.name + (r.phone ? r.phone : '');
							arr.push(r)
						}
					})
					this.userList = [{id:0,name1:'全部',name:'全部'}].concat(arr)
				})
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.t = 	this.$route.query.t;
			this.url = this.defUrl + '/api/sign/export/' + this.id
			this.openType = openType();
			this.getUserList()
			this.getList();
			if (this.openType != 'mob') {
				this.$nextTick(() => {
					this.pcPt = pcContentHeight('top');
				})
			}
		}
	})
</script>

<style scoped="scoped">
	.top {
		/* height: 290px; */
		height: 150px;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		box-sizing: border-box;
		z-index: 2;
	}

	.top.obt {
		width: 390px;
		left: 50%;
		transform: translateX(-50%);
	}

	.top-timer {
		height: 60px;
	}

	.top-content {
		height: 140px;
		box-sizing: border-box;
	}

	.content {
		/* padding-top: 280px; */
		padding-top: 280px;
	}

	.container_w_h {
		overflow-y: auto;
	}
</style>
